import { render, staticRenderFns } from "./PayWithPayPal.vue?vue&type=template&id=96eb0cf8&"
import script from "./PayWithPayPal.vue?vue&type=script&lang=js&"
export * from "./PayWithPayPal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports